import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { ResultModel } from "../models/result.model";
import { ClassModel } from '../models/class.model';
import { MajorModel } from '../models/major.model';
import { StudentModel } from '../models/student.model';
import { ImportParticipantModel } from '../models/import-participant.model';
import { ClassStudentModel } from '../models/classstudent.model';
import { ClassParticipantRoleModel } from '../models/classparticipantrole.model';
import { TrainingModel } from '../models/training.model';
import { MailModel } from '../models/mail.model';

@Injectable({
  providedIn: 'root'
})
export class ClassService extends BaseService {

  listAllForSelect(params?: any) {
    var query = this.getQueryString(params);
    if(query)
      return this.httpClient.get<ResultModel<ClassModel[]>>(this.getApiUrl(`classes?${query}`));
    else
      return this.httpClient.get<ResultModel<ClassModel[]>>(this.getApiUrl('classes'));
  }

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<ClassModel[]>>(this.getApiUrl('classes/list'), formData);
  }

  create(_class: ClassModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('classes'), _class);
  }

  update(_class: ClassModel) {
    return this.httpClient.put(this.getApiUrl('classes'), _class);
  }

  UpdateForAssessmentTemplateID(_class: ClassModel) {
    return this.httpClient.put(this.getApiUrl('classes/assessment'), _class);
  }

  get(id: string) {
    return this.httpClient.get<{ Class: ClassModel,ClassStudent:ClassStudentModel[] }>(this.getApiUrl('classes/' + id));
  }

  getForMail(id: string) {
    return this.httpClient.get<{ Class: ClassModel,Training:TrainingModel }>(this.getApiUrl('classes/mail/' + id));
  }

  getListGroup(trainingID:any) {
    return this.httpClient.get<ResultModel<any[]>>(this.getApiUrl(`classes/list-group/${trainingID}`));

  }

  importClassGroup(classModel: ClassModel[],importModel:ImportParticipantModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('classes/import?' + this.getQueryString(importModel)), classModel);
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('classes/' + id));
  }

  listAllRegisteredMajors(id: string, formData?: FormData) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/${id}/majors/registered`), formData);
  }

  listAllRegisteredMajorsForSelect(id: string) {
    return this.httpClient.get<ResultModel<MajorModel[]>>(this.getApiUrl(`classes/${id}/majors/registered`));
  }

  listAllUnregisteredMajorsForSelect(id: string) {
    return this.httpClient.get<ResultModel<MajorModel[]>>(this.getApiUrl(`classes/${id}/majors/unregistered`));
  }

  createClassMajor(classMajor: { ClassID: string, MajorID: string, InstructorID: string }) {
    var formData = new FormData();
    formData.append('pMajorID', classMajor.MajorID);
    formData.append('pInstructorID', classMajor.InstructorID);
    return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/${classMajor.ClassID}/majors/add`), formData);
  }

  deleteClassMajor(ClassID: string, MajorID: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`classes/${ClassID}/majors/delete/${MajorID}`));
  }

  listAllRegisteredStudents(id: string, formData?: FormData) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/${id}/students/registered`), formData);
  }

  listAllRegisteredClassStudentsForSelect(id: string) {
    return this.httpClient.get<ResultModel<StudentModel[]>>(this.getApiUrl(`classes/${id}/students/registered`));
  }

  listAllUnregisteredClassStudentsForSelect(id: string) {
    return this.httpClient.get<ResultModel<StudentModel[]>>(this.getApiUrl(`classes/${id}/students/unregistered`));
  }

  createClassStudent(classStudent: { ClassID: string, StudentID: string }) {
    var formData = new FormData();
    formData.append('pStudentID', classStudent.StudentID);
    return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/${classStudent.ClassID}/students/add`), formData);
  }

  deleteClassStudent(ClassID: string, StudentID: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`classes/${ClassID}/students/delete/${StudentID}`));
  }

  listDocumentAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<any>>(this.getApiUrl('classes/document/list'), formData);
  }
  listAllTrainingClassForCard(pInstructorID: string, pListType: string, pFilterDate?: Date) {
    var dateParam = '';
    if (pFilterDate) {
      let dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
      dateParam = '&pFilterDate=' + pFilterDate.toLocaleDateString('tr-TR', dateOptions);
    }
    return this.httpClient.get<ResultModel<ClassModel[]>>(this.getApiUrl(`classes/list-class-card?pInstructorID=${pInstructorID}&pListType=${pListType}${dateParam}`));
  }

  classParticipantRoleCreate(classParticipantRoleModel: ClassParticipantRoleModel[],ClassID: string) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/participantrole/${ClassID}`), classParticipantRoleModel);
  }

  updateClassRole(id:string,classID:string) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/classrole?pClassGroupIndex=${id}&pClassID=${classID}`), {});
  }

  sendmail(classes: ClassModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('classes/sendmail'), classes);
  }

  sendmailForAssessment(classes: ClassModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('classes/sendmail/assessment'), classes);
  }
  sendmailForParticipant2(mail: MailModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('classes/sendmail/student'), mail);
  }

  // sendmailForParticipant(pStudentID, pMailTitle, pMailDescription) {
  //   var formData = new FormData();
  //   formData.append('pStudentID', pStudentID);
  //   formData.append('pMailTitle', pMailTitle);
  //   formData.append('pMailDescription', pMailDescription);
  //   return this.httpClient.post<ResultModel>(this.getApiUrl(`classes/sendmail/student`), formData);
  // }

}
